import React from 'react'
import { Link } from 'react-router-dom'

const BookAppointment = () => {
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <Link
            to="/contact"
            className="py-2 px-4 border border-[#126CB3] text-[#126CB3] hover:bg-[#126CB3] hover:text-white my-font"
            onClick={scrollToTop}
        >
            Book an appointment
        </Link>
    )
}

export default BookAppointment